<template>
  <b-col class="m-auto text-center align-items-center">
    <img
      src="../../assets/login/mail_amarelo.svg"
      alt="Envelope com carta"
      class="w-50 mb-4"
    />

    <h2 class="text-tertiary">
      <span class="medium">{{
        resources.page.login.new.successPage.title
      }}</span>
    </h2>
    <h3 class="text-white">
      <span class="medium">{{
        resources.page.login.new.successPage.description
      }}</span>
    </h3>

    <br />

    <h5 class="text-white">
      {{ resources.page.login.new.successPage.ps
      }}<span class="text-tertiary">axel@teamculture.com.br</span>
    </h5>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters({
    resources: 'resources',
  }),
}
</script>
